import { PessoaFisica } from './pessoa-fisica';

export class BeneficioSocial {

	id:number;
	nome:string;
	descricao:string;
	origemSocial:string;
	
}